import classnames from 'classnames';
import { useMemo } from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { useOutletContext } from 'react-router-dom';
import { StockContextType } from './StockPage';

import { Article, ArticleRow, useArticlesQuery } from 'components/Article';
import { WordCloud } from 'components/WordCloud';
import { usePageTitle } from 'routes/Util/Util.hooks';

export const NewsPage = () => {
  const { symbol, stock } = useOutletContext<StockContextType>();
  usePageTitle(`${stock.krShortName} 뉴스`);
  const { data: articles, isLoading, isError, error } = useArticlesQuery(symbol as string);

  const sentence = useMemo(() => {
    return (articles?.docs || []).reduce((acc, article) => {
      const { title, description } = article.data();
      return `${acc} ${title} ${description}`;
    }, '');
  }, [articles?.docs]);

  if (isError) {
    return <div>{error}</div>;
  }

  return articles?.docs && articles?.docs?.length > 0 ? (
    <Row>
      <Col sm={12} lg={6}>
        <div className="border">
          <WordCloud sentence={sentence} />
        </div>
      </Col>
      <Col sm={12} lg={6} className="mt-3 mt-lg-0">
        {articles.docs.map((article, i) => {
          const articleData = article.data() as Article;
          return <ArticleRow key={article.id} className={classnames({ 'mt-0': i === 0 })} {...articleData} />;
        })}
      </Col>
    </Row>
  ) : (
    <Row>
      <Col>{isLoading ? '뉴스를 불러오는 중입니다...' : '뉴스가 없습니다.'}</Col>
    </Row>
  );
}
